import { type Dispatch, createContext } from 'react';
import type { ActionProps, StateProps } from './types.ts';

export const AppContext = createContext<{
  state: StateProps;
  dispatch: Dispatch<ActionProps>;
} | null>(null);
